import * as React from "react";
import { Field } from "formik";
import styled from "styled-components";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
import { Select } from "components/common";
const FieldContainer = styled.div`
  flex-basis: 100%;
`;
const InputFilterFieldValue = ({ fieldName, inputOptions }) => {
  const { t } = useTranslation("enterprise_data_lake");
  return /* @__PURE__ */ React.createElement(Field, { name: fieldName, required: true }, ({ field: { name, value, onChange }, meta: { error } }) => /* @__PURE__ */ React.createElement(FieldContainer, null, /* @__PURE__ */ React.createElement(Input, { error, name, formGroupClassName: "", id: name }, /* @__PURE__ */ React.createElement(
    Select,
    {
      options: inputOptions != null ? inputOptions : [],
      value,
      inputId: name,
      onChange: (newVal) => {
        onChange({ target: { value: newVal, name } });
      },
      placeholder: t("inputs_filter.placeholder"),
      allowCreate: true
    }
  ))));
};
export default InputFilterFieldValue;
